import React from 'react'
import { Link } from 'react-router-dom'
import clickDePagoMacro from '../../img/clickDePagoMacro.webp';
import QRMacro from '../../img/QRMacro.webp';
import macroPagar from '../../img/macroPagar.webp';
const BancoMacro = () => {
    return (
        <div className="bg-white animated fadeIn">
            <div className="container section">
                <div className="row">
                    <div className="center-vertical">
                        <div className="col s12 m12 l4 x4 center">
                            <Link to={""}><img src={clickDePagoMacro} className="responsive-img"/></Link>
                        </div>
                        <div className="col s12 m12 l4 x4 center">
                            <Link to={""}><img src={QRMacro} width="75%" height="75%" className="responsive-img"/></Link>
                        </div>
                        <div className="col s12  m12 l4  x4 center text-color-latitud">
                            <img src={macroPagar} className="responsive-img"/>
                            <Link to={"/pagopoliza"} className="btn btn-large waves-effect waves-light light-blue accent-3  white pulse" type="submit">Pagar Póliza
                                <i className="material-icons right">send</i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BancoMacro